import types from './types.js';

const openCsmModal = (id) => ({
  type: types.OPEN_CSM_MODAL,
  id: id

});

const openHamburgerModall = (id, columnId) => ({
  type: types.OPEN_DELETE_HAMBURGER_MODAL,
  id: id,
  columnId: columnId
});

const openHamburgerModal = (id, columnId, studyId, data) => {
  return (dispatch) => {
    dispatch(data);
    dispatch(openHamburgerModall(id, columnId, studyId));

  };
};
const setLoading = () => ({
  type: types.UPDATE_DROPDOWN_LOADING
})

const closeHamburgerModal = () => ({
  type: types.CLOSE_DELETE_HAMBURGER_MODAL
});

const closeModal = () => ({
  type: types.CLOSE_CSM_MODAL
});

const openConfirmBox = () => ({
  type: types.OPEN_CONFIRM_BOX
});

const closeConfirmBox = () => ({
  type: types.CLOSE_CONFIRM_BOX
});

const openEditBox = () => ({
  type: types.OPEN_EDIT_BOX
});

const closeEditBox = () => ({
  type: types.CLOSE_EDIT_BOX
});

const onDragEnd = (newColumnOrder) => ({
  type: types.ON_DRAG_END,
  payload: newColumnOrder

});

const onDropdownSelect = item => ({
  type: types.ON_DROPDOWN_SELECT,
  payload: item
});

const addNewTask = (data) => ({
  type: types.ADD_NEW_TASK,
  payload: data

});

const deleteCell = data => ({
  type: types.DELETE_TASK,
  payload: data
});

const fetchStepBegin = () => ({
  type: types.FETCH_STEP_BEGIN
});

const fetchStepDataSuccess = step => ({
  type: types.FETCH_STEP_SUCCESS,
  payload: step
});

const fetchRawStepDataSuccess = step => ({
  type: types.FETCH_RAW_STEP_SUCCESS,
  payload: step
});

const fetchStepError = error => ({
  type: types.FETCH_STEP_ERROR,
  payload: error
});

const editStepError = error => ({
  type: types.EDIT_STEP_ERROR,
  payload: error
});

const populateFormDropDown = data => ({
  type: types.POPULATE_FORM_DROPDOWN,
  payload: data
});

const addStepError = () => ({
  type: types.FETCH_STEP_ERROR,
  payload: 'Something went wrong'
});

const editTaskBegin = () => ({
  type: types.EDIT_TASK_BEGIN
});

const editTaskSuccess = () => ({
  type: types.EDIT_TASK_SUCCESS,
  payload: 'Your Names have been updated'
});

const editTaskError = () => ({
  type: types.EDIT_TASK_ERROR
});

const onTitleChange = (e) => ({
  type: types.ON_TITLE_CHANGE,
  payload: e.target.value
});

const onTitleChangeSubmit = () => ({
  type: types.ON_TITLE_CHANGE_SUBMIT,
  payload: 'Success'
});

const resetStateToLoading = () => ({
  type: types.RESET_STATE_TO_LOADING,
});

const toggleShowNotification = () => ({
  type: types.SAVED,
});

const onToggleLockStudy = (isLocked) => ({
  type: types.ON_TOGGLE_LOCK_STUDY,
  locked: isLocked
});

const onSearch = (value) => ({
  type: types.ON_STEP_SEARCH,
  value: value
});

const stepType = (type) => ({
  type: types.STEP_TYPE,
  payload: type

});

const addNewItemComplete = () => ({
  type: types.ADD_NEW_ITEM_COMPLETE
});

const openCacheModal = () => ({
  type: types.OPEN_CACHE_MODAL
});

const closeCacheModal = () => ({
  type: types.CLOSE_CACHE_MODAL
});

const getNextButtonOptionsBegin = () => ({
  type: types.GET_NEXT_BUTTON_OPTIONS_BEGIN
});

const getNextButtonOptionsSuccess = data => ({
  type: types.GET_NEXT_BUTTON_OPTIONS_SUCCESS,
  payload: { data }
});

const getNextButtonOptionsError = () => ({
  type: types.GET_NEXT_BUTTON_OPTIONS_ERROR
});

const setStepCategory = (category) => ({
  type: types.SET_STEP_CATEGORY,
  payload: category,
});

const clearPrimarySelection = () => ({
  type: "CLEAR_PRIMARY_SELECTION",
});

const setStepPagination = (paginationData) => ({
  type: types.SET_STEP_PAGINATION,
  payload: paginationData,
});


export const setInstructionContents = (contents) => ({
  type: types.SET_INSTRUCTION_CONTENTS,
  payload: contents,
});

export const setInstructionTemplate = (param) => ({
  type: types.SET_INSTRUCTION_TEMPLATE,
  payload: param,
});

export default {
  closeModal,
  onDragEnd,
  onDropdownSelect,
  addNewTask,
  deleteCell,
  fetchStepBegin,
  fetchStepDataSuccess,
  fetchStepError,
  editStepError,
  populateFormDropDown,
  fetchRawStepDataSuccess,
  addStepError,
  openHamburgerModal,
  closeHamburgerModal,
  openConfirmBox,
  closeConfirmBox,
  openEditBox,
  closeEditBox,
  editTaskBegin,
  editTaskSuccess,
  editTaskError,
  onTitleChange,
  onTitleChangeSubmit,
  resetStateToLoading,
  toggleShowNotification,
  openCsmModal,
  onToggleLockStudy,
  onSearch,
  stepType,
  addNewItemComplete,
  openCacheModal,
  closeCacheModal,
  getNextButtonOptionsBegin,
  getNextButtonOptionsSuccess,
  getNextButtonOptionsError,
  setStepCategory,
  clearPrimarySelection,
  setStepPagination,
  setInstructionContents,
  setInstructionTemplate,
  setLoading,
};
